import React from "react";
import JobTag from "./JobTag";

const JobCard = ({
  company_image_url,
  job_type,
  job_tenure,
  title,
  company_name,
  company_city,
  job_description,
  job_qualification,
  salary_min,
  salary_max,
}) => {
  // Format salary to Rupiah (IDR)
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat("id-ID", {
      style: "currency",
      currency: "IDR",
    }).format(amount);
  };

  return (
    <article className="flex flex-col gap-4 p-6 bg-white border border-solid border-zinc-200">
      <header className="flex justify-between items-start w-full">
        <div>
          {company_image_url && (
            <img src={company_image_url} alt={`${company_name} logo`} className="w-12 h-12" />
          )}
        </div>
        <div className="px-3 py-1 text-base text-indigo-600 border border-indigo-600 border-solid">
          {job_type}
        </div>
      </header>
      <h2 className="text-lg font-semibold leading-7 text-slate-800">{title}</h2>
      <div className="flex gap-2 items-center text-base text-slate-600">
        <span>{company_name}</span>
        <span className="opacity-30">•</span>
        <span>{company_city}</span>
        <span className="opacity-30">•</span>
        <span>{job_tenure}</span>
      </div>
      <div className="flex gap-2 items-center text-base text-slate-600 max-sm:flex-wrap">
        <span>{formatCurrency(salary_min)}</span>
        <span className="opacity-30">-</span>
        <span>{formatCurrency(salary_max)}</span>
        <span className="opacity-40 max-sm:text-semibold">per month</span>
      </div>
      <p className="text-base leading-6 text-slate-500">{job_description}</p>


      <div className="flex gap-2 max-sm:flex-wrap max-sm:gap-1">
        {job_qualification.split(",").map((tag, index) => (
          <JobTag key={index} text={tag.trim()} />
        ))}
      </div>
    </article>
  );
};

export default JobCard;
